import * as viewModeActions from './actions';
import * as lastStateActions from '../lastState/actions';
import { takeLatest } from '../../listenerMiddleware';

export const viewModeListeners = () => {
  watchLastState();
};

function watchLastState() {
  takeLatest([viewModeActions.changed, viewModeActions.expandedChanged], (action, { dispatch }) => {
    dispatch(lastStateActions.saveRequested());
  });
}
